import React from 'react';
import styled from 'styled-components';
import { Stat, IconType } from '@routific/hive';
import { MiniRouteContainerType } from './MiniRouteInfo';
import { GaugeSizeTypes } from './WorkingTimeInfo';
import OrdersInfoTooltip from './OrdersInfoTooltip';

interface Props {
  totalStops: number;
  type?: MiniRouteContainerType;
  gaugeSize?: GaugeSizeTypes;
  loading?: boolean;
  ordersCount: number;
  disabled?: boolean;
}

const StopsInfoItem = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
`;

const StopsInfo: React.FC<Props> = ({
  totalStops, type, gaugeSize, loading = false, ordersCount = 0,
  disabled,
}) => {
  const string = loading ? '--' : `${ordersCount}`;

  return (
    <StopsInfoItem
      className="item"
      data-cy={type && `${type}-route-utilization-orders`}
      data-testid={type && `${type}-route-utilization-orders`}
    >
      <Stat
        size={gaugeSize}
        label={{ value: string }}
        percent={null}
        icon={IconType.Orders}
        tooltipContent={<OrdersInfoTooltip stopsCount={totalStops} />}
        disabled={disabled}
      />
    </StopsInfoItem>
  );
};

export default StopsInfo;
